<form [formGroup]="filterForm">
    Filter By Manufacturer
    <select class="dropdown" forControlName="manufacturer" (change)="onManufacturerChange($event.target.value)">
        <option  value=""><div class="dropdown-item">All</div></option>
        <option [value]="m" *ngFor="let m of manufacturers"><div class="dropdown-item">{{m}}</div></option>
    </select>
</form>